import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import { ShareButton } from '../../commons/ShareButton/ShareButton.component'

export default class Banner extends Component {

  _renderStyle(img){
    let style = {
      backgroundImage: 'url(' + img + ')'
    }
    return style
  }

  render(){

    const { item } = this.props

    return(
      <div className='banner-wrapper' onClick={() => window.open(item.link, '_blank') }>
        <div className='banner-left' style={this._renderStyle(item.image)}>
        </div>
        <div className='bottom-overlay'>
          <ShareButton shareUrl={item.link} />
          <a target='_blank' href={item.link} rel='noreferrer'>
            <h2>{item.name}</h2>
            {!!item.bajada && <h3><i className='fa fa-map-marker' aria-hidden='true'></i>&emsp;{item.bajada}</h3>}
            <hr/>
            <p>{item.description}</p>
          </a>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/PageHome/components/banner.js